package com.sddamico.draftmachine.components.widgets

import androidx.compose.runtime.Composable
import com.sddamico.draftmachine.ds.DmColor
import com.sddamico.draftmachine.ds.DmEffects
import com.sddamico.draftmachine.ds.DmType
import com.sddamico.draftmachine.ds.displayFlex
import com.sddamico.draftmachine.ds.motion.TransitionRole
import com.sddamico.draftmachine.ds.motion.transitionRole
import com.sddamico.draftmachine.ds.shadowInset
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/** The recessed segmented control from frames 1a–1b (Official / Community / Yours). */
@Composable
fun SegmentedTabs(
  options: List<String>,
  selected: Int,
  modifier: Modifier = Modifier,
  onSelect: (Int) -> Unit,
) {
  Div(
    attrs = modifier.displayFlex().gap(6.px).padding(4.px)
      .backgroundColor(DmColor.surfaceInset)
      .border(1.px, LineStyle.Solid, DmColor.borderStrong)
      .borderRadius(DmEffects.radiusMd)
      .shadowInset()
      .toAttrs { attr("role", "tablist") }
  ) {
    options.forEachIndexed { i, label ->
      val active = i == selected
      Div(
        attrs = Modifier
          .flex(1).displayFlex().alignItems(AlignItems.Center).justifyContent(JustifyContent.Center)
          .height(36.px).borderRadius(DmEffects.radiusSm)
          .fontFamily(*DmType.body).fontSize(DmType.textSm).fontWeight(DmType.weightSemibold)
          .then(
            if (active) Modifier
              .transitionRole(TransitionRole.Segment)
              .border(1.px, LineStyle.Solid, DmColor.brass600)
              .styleModifier { property("background-image", DmEffects.gradientSteel) }
              .color(DmColor.brass300)
            else Modifier.color(DmColor.textMuted).cursor(Cursor.Pointer)
          )
          .toAttrs {
            attr("role", "tab")
            attr("aria-selected", active.toString())
            if (!active) onClick { onSelect(i) }
          }
      ) { Text(label) }
    }
  }
}
